/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect } from "react";

// TODO: @Manish PLease remove any type from here
export const useOutsideClick = (ref: any, cb: () => void) => {
  const handleClick = useCallback(
    (e: any) => {
      if (ref?.current && !ref?.current?.contains(e.target)) {
        cb();
      }
    },
    [cb, ref]
  );

  useEffect(() => {
    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [handleClick]);
};
